export const tickerItems = [
  '17:42 某综艺录制现场路透流出，节目组暂未回应',
  '17:15 音乐平台新歌评论区一夜涨到 4 万条',
  '16:58 某品牌官微悄悄删掉一条合作预告',
  '16:20 电竞战队赛后采访原片被扒出另一版本',
  '15:47 短剧男主换角传闻扩散，制片方挂出辟谣',
  '15:10 某剧集定档海报更换主视觉，番位疑似调整',
  '14:36 直播回放里的一句口误被做成表情包',
];

export const heroLead = {
  tag: '今日主推',
  stamp: '18:00 准点',
  time: '17:58 更新',
  title: '六点前最后一批瓜集中放出，三条线索在同一条时间线上对上了',
  excerpt:
    '从午后的一张路透开始，到傍晚被翻出的旧采访，黑料六点今日六点把散落的片段按时间拼回同一条线。评论区已经有人把两段原片逐帧对比，讨论度还在涨。',
  cover:
    'https://readdy.ai/api/search-image?query=Warm%20dusk%20editorial%20cover%20art%2C%20abstract%20city%20silhouette%20layers%20in%20deep%20vermillion%20and%20amber%20light%2C%20cinematic%20grain%20texture%2C%20moody%20atmospheric%20composition%2C%20no%20text%2C%20high%20detail%2C%20magazine%20cover%20aesthetic&width=1200&height=800&seq=hlld-hero-lead-01&orientation=landscape',
  heat: '12.8 万',
  comments: 3421,
  follows: 986,
};

export const heroSideCards = [
  {
    tag: '热帖',
    time: '17:31',
    title: '同一段采访出现两个剪辑版本，网友把时间码贴了出来',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20coral%20gradient%20cover%20art%20with%20layered%20paper%20texture%2C%20editorial%20magazine%20style%2C%20soft%20cinematic%20grain%2C%20no%20text%2C%20minimal%20bold%20composition&width=800&height=600&seq=hlld-hero-side-01&orientation=landscape',
    comments: 1204,
    heat: '5.6 万',
  },
  {
    tag: '新瓜',
    time: '17:09',
    title: '品牌合作预告被秒删，截图比官宣先到一步',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20studio%20backdrop%20in%20dusty%20rose%20and%20warm%20gold%2C%20soft%20dramatic%20lighting%2C%20editorial%20photography%20texture%2C%20clean%20minimal%20layers%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=hlld-hero-side-02&orientation=landscape',
    comments: 862,
    heat: '3.9 万',
  },
  {
    tag: '待跟进',
    time: '16:44',
    title: '定档海报换主视觉，番位顺序被放大核对',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20abstract%20night%20scene%20in%20deep%20maroon%20and%20warm%20orange%20glow%2C%20cinematic%20blur%2C%20atmospheric%20editorial%20cover%20art%2C%20rich%20texture%2C%20no%20text%2C%20elegant%20composition&width=800&height=600&seq=hlld-hero-side-03&orientation=landscape',
    comments: 640,
    heat: '2.7 万',
  },
];

export const timelineItems = [
  {
    time: '18:00',
    tag: '准点',
    title: '黑料六点每日准点汇总上线，今天新瓜已完成归档',
    summary: '页面按 18:00 的节点把全天片段重新排序，先给结论再给线索来源。',
    comments: 2103,
    heat: '9.1 万',
  },
  {
    time: '17:31',
    tag: '跟进',
    title: '两个剪辑版本的时间码被网友逐帧对齐',
    summary: '有用户把两份原片导入同一条轨道，标出了 6 处节奏差异。',
    comments: 1288,
    heat: '6.2 万',
  },
  {
    time: '17:09',
    tag: '线索',
    title: '秒删的合作预告，截图出现得比官宣更早',
    summary: '截图显示发布时间与官微动作相差不到 4 分钟，双方均未回应。',
    comments: 967,
    heat: '4.8 万',
  },
  {
    time: '16:44',
    tag: '核查',
    title: '定档海报更换主视觉，番位顺序被放大',
    summary: '同一部剧两版海报的站位不同，讨论集中在署名顺序上。',
    comments: 742,
    heat: '3.4 万',
  },
  {
    time: '16:20',
    tag: '补充',
    title: '赛后采访原片出现另一版本，时长相差 58 秒',
    summary: '俱乐部方面暂未回应，粉丝已在评论区贴出台本对照。',
    comments: 611,
    heat: '2.9 万',
  },
  {
    time: '15:47',
    tag: '旧瓜回锅',
    title: '短剧换角传闻扩散，制片方挂出辟谣声明',
    summary: '本次黑料六点每日定时追踪把三周前的旧帖也一并串了进来。',
    comments: 508,
    heat: '2.1 万',
  },
];

export const bigFeedItems = [
  {
    id: 1,
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20cover%20art%20with%20warm%20terracotta%20and%20cream%20paper%20layers%2C%20soft%20cinematic%20light%2C%20grainy%20texture%2C%20no%20text%2C%20bold%20minimal%20magazine%20composition&width=800&height=600&seq=hlld-feed-01&orientation=landscape',
    tag: '综艺',
    time: '17:58',
    title: '录制现场路透流出，站位顺序被反复截图',
    excerpt: '路透只有 9 秒，评论区把每个人的进出场顺序排成了一张表。',
    comments: 3421,
    heat: '12.8 万',
  },
  {
    id: 2,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20dusk%20cityscape%20in%20burnt%20orange%20and%20deep%20plum%20tones%2C%20cinematic%20haze%2C%20editorial%20cover%20art%2C%20rich%20grain%20texture%2C%20no%20text%2C%20layered%20composition&width=800&height=600&seq=hlld-feed-02&orientation=landscape',
    tag: '剧集',
    time: '17:31',
    title: '两版采访剪辑差在哪，时间码已经贴出来了',
    excerpt: '有人把关键 6 处节奏差异标红，配文只有一句「自己看」。',
    comments: 1288,
    heat: '6.2 万',
  },
  {
    id: 3,
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20studio%20still%20life%20with%20warm%20gold%20fabric%20and%20shadow%2C%20editorial%20photography%2C%20muted%20cream%20backdrop%2C%20cinematic%20grain%2C%20no%20text%2C%20elegant%20minimal%20composition&width=800&height=600&seq=hlld-feed-03&orientation=landscape',
    tag: '商务',
    time: '17:09',
    title: '合作预告秒删，截图比官宣早到 4 分钟',
    excerpt: '品牌方暂未回应，评论区在核对发布时间线。',
    comments: 967,
    heat: '4.8 万',
  },
  {
    id: 4,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20poster%20art%20with%20overlapping%20warm%20red%20and%20sand%20shapes%2C%20paper%20cut%20texture%2C%20editorial%20cover%20style%2C%20cinematic%20light%2C%20no%20text%2C%20bold%20graphic%20layout&width=800&height=600&seq=hlld-feed-04&orientation=landscape',
    tag: '海报',
    time: '16:44',
    title: '定档海报换主视觉，番位顺序被放大核对',
    excerpt: '两版站位不同，讨论集中在署名先后上。',
    comments: 742,
    heat: '3.4 万',
  },
  {
    id: 5,
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20esports%20arena%20lights%20in%20amber%20and%20deep%20red%2C%20blurred%20crowd%2C%20cinematic%20editorial%20cover%20art%2C%20grainy%20texture%2C%20no%20text%2C%20atmospheric%20composition&width=800&height=600&seq=hlld-feed-05&orientation=landscape',
    tag: '电竞',
    time: '16:20',
    title: '赛后采访原片有时长差，台本对照已出炉',
    excerpt: '两个版本相差 58 秒，俱乐部方面保持沉默。',
    comments: 611,
    heat: '2.9 万',
  },
  {
    id: 6,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20cover%20in%20coral%20peach%20and%20deep%20brown%2C%20soft%20blurred%20shapes%2C%20editorial%20art%20direction%2C%20cinematic%20grain%2C%20no%20text%2C%20refined%20minimal%20look&width=800&height=600&seq=hlld-feed-06&orientation=landscape',
    tag: '短剧',
    time: '15:47',
    title: '换角传闻扩散，制片方挂出辟谣声明',
    excerpt: '黑料六点每日定时追踪把三周前的旧帖也串了进来。',
    comments: 508,
    heat: '2.1 万',
  },
  {
    id: 7,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20live%20stream%20screen%20glow%20in%20warm%20orange%20and%20magenta%2C%20soft%20bokeh%2C%20editorial%20cover%20art%2C%20cinematic%20grain%20texture%2C%20no%20text%2C%20moody%20composition&width=800&height=600&seq=hlld-feed-07&orientation=landscape',
    tag: '直播',
    time: '15:10',
    title: '回放里一句口误被做成表情包，二创已经出圈',
    excerpt: '原片段被剪了 12 个版本，评论区在选最像的那一版。',
    comments: 433,
    heat: '1.8 万',
  },
  {
    id: 8,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20concert%20stage%20silhouette%20in%20deep%20red%20and%20gold%20haze%2C%20cinematic%20editorial%20cover%20art%2C%20grainy%20atmosphere%2C%20no%20text%2C%20dramatic%20minimal%20layout&width=800&height=600&seq=hlld-feed-08&orientation=landscape',
    tag: '音乐',
    time: '14:36',
    title: '新歌评论区一夜四万条，热评全在问同一件事',
    excerpt: '凌晨上线，到六点前的第一波讨论已经跑完。',
    comments: 389,
    heat: '1.6 万',
  },
  {
    id: 9,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20fashion%20editorial%20backdrop%20in%20warm%20beige%20and%20rust%2C%20soft%20fabric%20folds%2C%20cinematic%20light%2C%20grain%20texture%2C%20no%20text%2C%20clean%20elegant%20composition&width=800&height=600&seq=hlld-feed-09&orientation=landscape',
    tag: '时尚',
    time: '13:52',
    title: '造型与三年前的旧图高度雷同，对比图被顶上热评',
    excerpt: '造型团队暂未说明，讨论集中在版权归属上。',
    comments: 322,
    heat: '1.3 万',
  },
];

export const beforeSixItems = [
  { time: '17:42', title: '综艺录制路透流出，9 秒素材被逐帧截图', source: '网友投稿' },
  { time: '17:15', title: '新歌评论区涨到四万条，热评清一色追问', source: '评论区' },
  { time: '16:58', title: '品牌官微悄悄删掉合作预告，无任何说明', source: '截图比对' },
  { time: '16:20', title: '赛后采访原片被扒出另一版本，时长差 58 秒', source: '原片对照' },
  { time: '15:47', title: '短剧换角传闻扩散，制片方挂出辟谣', source: '官方声明' },
];

export const afterSixItems = [
  { time: '18:02', title: '对方工作室发布一句回应：内容不实，已交律师处理', source: '官微' },
  { time: '18:05', title: '节目组更新录制花絮，画面顺序与路透不一致', source: '官方物料' },
  { time: '18:09', title: '品牌把预告重新发了一遍，只是换了发布时间', source: '官微' },
  { time: '18:14', title: '俱乐部发长图说明采访剪辑流程，未提时长差', source: '官方声明' },
  { time: '18:21', title: '有用户把所有回应整理成一张时间线图', source: '网友整理' },
];

export const hotComments = [
  {
    user: '瓜田巡视员',
    badge: '常驻',
    floor: '1F',
    time: '6 分钟前',
    content:
      '把两段原片丢进同一条轨道就清楚了，差的那 58 秒正好卡在提问前后。建议先看这一段再回来说话。',
    likes: 2841,
    replies: 213,
  },
  {
    user: '准点打卡人',
    badge: '每日准点',
    floor: '4F',
    time: '11 分钟前',
    content:
      '每天六点来这里刷首页已经成习惯了，摘要比零零散散刷到的快一步，还能顺着时间线把前因后果补齐。',
    likes: 1673,
    replies: 88,
  },
  {
    user: '截图档案馆',
    badge: '考据',
    floor: '9F',
    time: '18 分钟前',
    content:
      '秒删那条我这边有原始截图，发布时间比官宣早了不到四分钟。已经贴在楼上了，自己看时间戳。',
    likes: 1204,
    replies: 156,
  },
  {
    user: '前排吃瓜',
    badge: '活跃',
    floor: '17F',
    time: '25 分钟前',
    content:
      '番位那张海报换了主视觉，但站位其实没变，被放大的是署名顺序。别被带节奏，先看图。',
    likes: 862,
    replies: 74,
  },
  {
    user: '夜班编辑',
    badge: '观察',
    floor: '23F',
    time: '32 分钟前',
    content:
      '这一波回应的节奏很整齐，像是统一口径。继续挖的话，建议盯今晚会不会有第二份声明。',
    likes: 640,
    replies: 51,
  },
];

export const hotRanking = [
  { rank: 1, title: '综艺录制现场路透流出', heat: 128400, trend: 'up' },
  { rank: 2, title: '两版采访剪辑时间码对照', heat: 86200, trend: 'up' },
  { rank: 3, title: '合作预告秒删事件', heat: 64100, trend: 'flat' },
  { rank: 4, title: '定档海报更换主视觉', heat: 48300, trend: 'up' },
  { rank: 5, title: '赛后采访时长差 58 秒', heat: 36700, trend: 'down' },
  { rank: 6, title: '短剧换角辟谣声明', heat: 28400, trend: 'flat' },
  { rank: 7, title: '直播回放口误二创', heat: 21900, trend: 'up' },
  { rank: 8, title: '新歌评论区热评追问', heat: 17300, trend: 'up' },
];

export const topicTags = [
  { name: '今日六点', count: 4821, hot: true },
  { name: '准点汇总', count: 3267, hot: true },
  { name: '时间线', count: 2914, hot: false },
  { name: '截图比对', count: 2380, hot: true },
  { name: '番位', count: 1902, hot: false },
  { name: '秒删', count: 1644, hot: false },
  { name: '原片对照', count: 1388, hot: true },
  { name: '辟谣', count: 1207, hot: false },
  { name: '热评', count: 986, hot: false },
  { name: '评论区挖线索', count: 812, hot: false },
  { name: '每日定时', count: 704, hot: false },
  { name: '旧瓜回锅', count: 621, hot: false },
];

export const statItems = [
  { label: '今日新增', value: '37', unit: '条' },
  { label: '准点归档', value: '18:00', unit: '整点' },
  { label: '评论互动', value: '8,412', unit: '条' },
  { label: '在线吃瓜', value: '2.6', unit: '万人' },
];